export function filtersToParams(filters: { [value: string]: string | { [value: string]: string } }) {
  const arr = [];
  for (const [key, value] of Object.entries(filters)) {
    arr.push(`"filters[${key}]":"${value}"`);
  }
  const str = `{${arr.join(',')}}`;

  return JSON.parse(str);
}

export function sortToParams(sort: { [value: string]: string | { [value: string]: string } }) {
  const arr = [];
  for (const [key, value] of Object.entries(sort)) {
    arr.push(`"sort[${key}]":"${value}"`);
  }
  const str = `{${arr.join(',')}}`;

  return JSON.parse(str);
}
